import Layout from '../views/layout/layout'

export  default   {
    path: '/content',
    name: 'content',
    component: Layout,
    children: [
        {
            path: '/content/qr',
            name: 'qrCode',
            component:()=>import('../views/content/qr/index'),
            meta: { title: '二维码管理',keepAlive:true }
        },
        {
            path: '/content/qr_detail',
            name: 'qrdetail',
            component:()=>import('../views/content/qr/detail'),
            meta: { title: '二维码管理' }
        },
        {
            path: '/content/active',
            name: 'active_menu',
            component:()=>import('../views/content/active/active_menu'),
            meta: {title: '活动管理',keepAlive:true}
        },
        {
            path: '/content/active_result',
            name: 'active_result',
            component:()=>import('../views/content/active/active_result'),
            meta: {title: '查看活动结果'}
        },
        {
            path: '/content/active_edit',
            name: 'active_edit',
            component:()=>import('../views/content/active/active_edit'),
            meta: {title: '活动新增'}
        },
        {
            path: '/content/active_update',
            name: 'active_update',
            component:()=>import('../views/content/active/active_update'),
            meta: {title: '活动修改'}
        },
    ]
}